import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { Baggage } from '../../../../../BaggageService/types';
import { SelectedUpgrade } from '../../../types';
import Radio from '../../../../../Radio';
import { getBaggageServicesCalculatedCountInfo, getPassengerBaggageState } from '../../../store/selector';
import { getGdsServiceCalculatedCountInfo } from '@shared/lib/gdsService/getGdsServiceCalculatedCountInfo';
import { buildDataAttributes } from '@shared/lib/dom';
import { Passenger } from '../../../../types';

interface Props {
	className?: string;
	passenger: Passenger;
	baggages: Baggage[];
	segmentIds: string[];
	segmentId: string;
	disabled?: boolean;
	onChange: (items: SelectedUpgrade[]) => void;
}

const PassengerBaggageRadio: React.FC<Props> = ({
	className,
	passenger,
	baggages,
	segmentIds,
	segmentId,
	disabled,
	onChange
}) => {
	const { BaggagePassenger: css } = useTheme('UpgradeBaggageDialog');

	const { items, selectedCount } = useSelector(
		getPassengerBaggageState({ passengerId: passenger.id, baggage: baggages, segmentIds, segmentId })
	);

	const gdsServicesCalculatedCountInfo = useSelector(getBaggageServicesCalculatedCountInfo);

	const canAddedCount = React.useMemo(() => {
		const segmentId = segmentIds[0];
		const baggage = baggages[0];

		return getGdsServiceCalculatedCountInfo(passenger.id, segmentId, gdsServicesCalculatedCountInfo, {
			rfisc: baggage?.rfics,
			subType: baggage?.type
		})?.diffCount;
	}, [gdsServicesCalculatedCountInfo, baggages, segmentIds, passenger]);

	const isChecked = !!selectedCount;
	const isDisabled = disabled || (canAddedCount === 0 && !isChecked);

	const onChangeHandler = useCallback(
		(_: React.MouseEvent<HTMLButtonElement>) => {
			const changedItems = items
				.filter(item => !segmentId || (segmentId && item.segmentIds.includes(segmentId)))
				.map(item => ({ ...item, count: isChecked ? 0 : 1 }));

			onChange(changedItems);
		},
		[isChecked, segmentId, items, onChange]
	);

	return (
		<div
			className={cn(css.checkbox_wrapper, className)}
			{...buildDataAttributes({
				'test-id': 'baggage-counter',
				'passenger-id': passenger.id,
				'segment-id': segmentId
			})}
		>
			<Radio
				classes={{
					root: css.checkbox_root,
					checked: css.checkbox_rootChecked
				}}
				checked={isChecked}
				disabled={isDisabled}
				onClick={onChangeHandler}
			/>
		</div>
	);
};

export default PassengerBaggageRadio;
